import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { fetchProducts } from "../../actions/appointmentActions";
import debounce from "lodash.debounce";
import { refreshTimeout, refreshAlertText } from "../../helpers";
import InstructorDash from "../core/InstructorDash";
import md5 from "md5";

const mapStateToProps = state => {
  return {
    appointments: state.appointments.appointments,
    loading: state.appointments.loading,
    error: state.appointments.error
  };
};

class InstructorDayView extends Component {
  appointmentDebounce = debounce(() => {
    const oldData = md5(JSON.stringify(this.props.appointments));
    localStorage.setItem("oldData", oldData);
    this.props.dispatch(fetchProducts());
  }, refreshTimeout);

  componentDidMount() {
    const { dispatch } = this.props;

    if (Object.keys(this.props.appointments)[0] === undefined) {
      dispatch(fetchProducts());
    }
    this.appointmentDebounce();
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
  componentWillMount() {
    localStorage.removeItem("oldData");
  }
  componentDidUpdate() {
    const oldData = localStorage.getItem("oldData");
    if (oldData && oldData !== md5(JSON.stringify(this.props.appointments))) {
      alert(refreshAlertText);
      localStorage.removeItem("oldData");
    }
    this.appointmentDebounce();
  }
  componentWillUnmount() {
    localStorage.removeItem("oldData");
    this.appointmentDebounce.cancel();
  }
  render() {
    const loading = this.props.loading;
    const error = this.props.error;
    if (error) {
      return <div>Error! {error.message}</div>;
    }
    if (loading) {
      return <div>Loading...</div>;
    }

    return (
      <div>
        <InstructorDash
          index={this.props.match.params.day}
          {...this.props.children}
          {...this.props}
        />
      </div>
    );
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    null
  )(InstructorDayView)
);
